import {
  OPENDOCK_LIBRARY_CATEGORY,
  SHIPPER_GUIDE_LIBRARY_CATEGORY,
} from 'managed-analytics/domain/demoLibrary'

/**
 * A performance report sample shown on the public demo page. The PDFs live in
 * `public/samples`, which is served unauthenticated at the site root — a
 * sample must use invented figures, never a real customer's report.
 */
export type DemoPerformanceReport = {
  id: string
  // A library category label, so the headings here match the Analytics Library.
  category: string
  reportName: string
  cadence: string
  description: string
  pdfUrl: string
  fileName: string
}

export const DEMO_PERFORMANCE_REPORTS: Array<DemoPerformanceReport> = [
  {
    id: 'shipperguide-freight',
    category: SHIPPER_GUIDE_LIBRARY_CATEGORY,
    reportName: 'Freight Performance Report',
    cadence: 'Monthly',
    description:
      'Lane-level spend, savings and carrier on-time performance across your ShipperGuide network.',
    pdfUrl: '/samples/shipperguide-freight-performance-report.pdf',
    fileName: 'shipperguide-freight-performance-report.pdf',
  },
  {
    id: 'opendock-warehouse',
    category: OPENDOCK_LIBRARY_CATEGORY,
    reportName: 'Warehouse Performance Report',
    cadence: 'Weekly',
    description:
      'Appointment compliance, dwell time and detention by warehouse across your dock network.',
    pdfUrl: '/samples/opendock-warehouse-performance-report.pdf',
    fileName: 'opendock-warehouse-performance-report.pdf',
  },
]

export function groupDemoPerformanceReportsByCategory(
  reports: Array<DemoPerformanceReport>
): Array<[string, Array<DemoPerformanceReport>]> {
  const sections: Array<[string, Array<DemoPerformanceReport>]> = []

  reports.forEach(report => {
    const section = sections.find(([category]) => category === report.category)

    if (section) {
      section[1].push(report)
      return
    }

    sections.push([report.category, [report]])
  })

  return sections
}
